export const links = {
    instagram: 'https://www.instagram.com/dionysuspool/',
    twitter: 'https://twitter.com/dionysuspool',
    ds: 'https://discord.com/invite/njHDFfz4',
    tg: "https://t.me/dionysusnews?utm_source=hs_email&utm_medium=email&utm_content=2&_hsenc=p2ANqtz-9Rku6hYVFAPBdcu9f1hwz7FqQwopcGX4xmpmlkakovkX0alAOZo42sqW9xzECO0ds2JO_6v4RkH6kINgEv4AdTBN0FTg&_hsmi=2",
    yt: 'https://www.youtube.com/channel/UCCgsHE_AfdZvp2VQjA3KhoQ',
}